module.exports = __webpack_public_path__ + "static/media/human-advantage-logo.67fcdca6.png";